import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowRight, BadgeCheck, FileText } from 'lucide-react';
import { motion } from 'framer-motion';
import {
    FaShieldAlt,        // For Zero Depreciation Cover
    FaTools,            // For Engine Protection Cover
    FaTruckPickup,      // For Roadside Assistance
    FaOilCan,           // For Consumables Cover
    FaUserShield,       // For Personal Accident Cover
    FaCloudSunRain,
    FaUserLock,
    FaCarCrash,
    FaCarSide,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import AdBanner from "../AdPage/AdBanner";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const HeroMotoCorpTwoWheelerInsurance = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
      question: "Is zero depreciation cover useful for Hero bikes?",
      answer: "Yes, especially for new models like Xtreme 160R or Glamour to get full settlement without part value deduction.",
    },
    {
      question: "Can I insure my old Hero bike online?",
      answer: "Yes, online platforms allow easy renewal or fresh purchase for used two-wheelers.",
    },
    {
      question: "Which Hero model has the lowest insurance cost?",
      answer: "HF Deluxe and Splendor Plus usually have the most affordable premiums.",
    },
    {
      question: "Is insurance mandatory for scooters like Destini or Maestro?",
      answer: "Yes, third-party insurance is legally required. Comprehensive cover is recommended.",
    },
    {
      question: "Can I transfer NCB from another bike to my new Hero?",
      answer: "Yes, if the new bike is registered in the same owner’s name.",
    },
    {
      question: "Is roadside assistance worth it for Hero scooters?",
      answer: "Absolutely, it’s useful in case of flat tyres, dead batteries or emergencies.",
    },
    {
      question: "What happens if my policy lapses?",
      answer: "You may need an inspection and could lose accumulated NCB benefits.",
    },
    {
      question: "Does Hero offer bundled in-house insurance?",
      answer: "Yes, but comparing external options often gives you better value.",
    },
    {
      question: "Are Hero electric bikes covered by standard insurance?",
      answer: "Hero’s EVs will need EV-specific insurance plans which most major insurers now offer.",
    },
    {
      question: "Do I need an engine protection cover for my Hero bike?",
      answer: "Yes, especially in cities prone to waterlogging.",
    },
    {
      question: "Can I pay Hero insurance premiums monthly?",
      answer: "Some insurers offer EMI options for annual premiums.",
    },
    {
      question: "Are modifications covered under Hero insurance?",
      answer: "Only if declared and approved by your insurer.",
    },
    {
      question: "Does insurance cover helmet or pillion rider?",
      answer: "Not by default. You can add these with optional personal accident covers.",
    },
    {
      question: "Can I buy insurance for a Hero bike without inspection?",
      answer: "Yes, if the previous policy hasn’t expired for too long.",
    },
    {
      question: "Is online claim filing available for Hero bikes?",
      answer: "Yes, most insurers offer mobile apps or web platforms for fast claims.",
    },
    {
      question: "How long does claim settlement take?",
      answer: "Typically 7 to 10 working days with complete documentation.",
    },
    {
      question: "Is tyre damage covered under Hero bike insurance?",
      answer: "Only if damaged in an accident. Tyre Protect add-ons cover additional wear.",
    },
    {
      question: "Can I buy Hero insurance directly from TheFinMaster?",
      answer: "Yes, you can compare plans, calculate premiums and buy online instantly.",
    },
    {
      question: "What’s the fine for riding a Hero bike without insurance?",
      answer: "₹2,000 for first-time offenders as per the Motor Vehicles Act.",
    },
    {
      question: "Does insurance cover bike theft?",
      answer: "Yes, comprehensive plans cover theft. FIR and claim process is required.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const cardsNew = [
    {
      title: "Zero Depreciation Cover",
      description: "Ensures full compensation without deduction on parts value. Great for new bikes and scooters.",
      icon: <FaShieldAlt className="text-4xl text-red-500 mb-4" />,
    },
    {
      title: "Engine Protection Cover",
      description: "Important in monsoon-prone areas to guard against water damage.",
      icon: <FaTools className="text-4xl text-yellow-600 mb-4" />,
    },
    {
      title: "Roadside Assistance",
      description: "Helpful for unexpected breakdowns or battery issues.",
      icon: <FaTruckPickup className="text-4xl text-blue-500 mb-4" />,
    },
    {
      title: "Consumables Cover",
      description: "Pays for small parts like nuts, bolts, oil and coolant during repairs.",
      icon: <FaOilCan className="text-4xl text-green-600 mb-4" />,
    },
    {
      title: "Personal Accident Cover",
      description: "Offers financial support in case of injury or death due to accidents.",
      icon: <FaUserShield className="text-4xl text-purple-600 mb-4" />,
    },
  ];

  const features = [
    { icon: '🛡️', text: 'Reliable & Accurate Estimates' },
    { icon: '⏱️', text: 'Takes Less Than a Minute' },
    { icon: '📉', text: 'Instantly Shows Premium Breakup' },
    { icon: '📄', text: 'No Paperwork or Documentation' },
    { icon: '📲', text: 'Easy to Use on Any Device' },
    { icon: '💰', text: 'Helps You Save on Insurance' },
  ];
const heromotocorpInsurance = [
    {
      name: "Splendor Plus",
      path: "/hero-splendor-plus-bike-insurance", 
      image: "/assets/herosplendorplus.jpeg",
    },
     {
      name: "Hf Deluxe",
      path: "/hero-hf-deluxe-bike-insurance", 
      image: "/assets/herohfdeluxe.jpeg",
    },
     {
      name: "Xtreame-125",
      path: "/hero-xtreame-125-bike-insurance", 
      image: "/assets/heroxtreame125.jpeg",
    },
     {
      name: "Glamour XTEC",
      path: "/hero-glamour-xtec-bike-insurance", 
      image: "/assets/heroglamourxtec.jpeg",
    },
   {
      name: "Super Splendor XTEC",
      path: "/hero-super-splendor-xtec-bike-insurance", 
      image: "/assets/herosupersplendorxtec.jpeg",
    },
    {
      name: "Karizma XMR 250",
      path: "/hero-karizma-xmr-250-bike-insurance", 
      image: "/assets/herokarizma-xmr-250.jpeg",
    },
    {
      name: "Xpulse 421",
      path: "/hero-xpulse-421-bike-insurance", 
      image: "/assets/heroxpulse421.jpeg",
    },
  ];
  return (
    <>
      <Helmet>
        <title>Hero MotoCorp Two-Wheeler Insurance in India – Compare Quotes & Buy Online</title>
        <meta
          name="description"
          content="Explore Hero MotoCorp two-wheeler insurance options in India. Compare quotes, customize coverage, and buy online to protect your Hero bike or scooter."
        />
        <meta
          name="keywords"
          content="hero motocorp insurance, two-wheeler insurance india, hero splendor insurance, hero destini insurance, hero xtreme insurance, bike insurance quotes"
        />
         <link rel="canonical" href="https://thefinmaster.com/hero-moto-corp-two-wheeler-insurance" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
        {/* <link rel="canonical" href="https://thefinmaster.com/hero-motocorp-two-wheeler-insurance" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard, max-video-preview:-1" />
        <meta property="og:title" content="Hero MotoCorp Two-Wheeler Insurance in India" />
        <meta property="og:description" content="Compare and buy Hero MotoCorp two-wheeler insurance online with ease." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://thefinmaster.com/hero-motocorp-two-wheeler-insurance" />
        <meta name="twitter:card" content="summary_large_image" /> */}
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
        <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
          <AdBanner displayOrder="1" />
        </div>
      </div>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800">Home</Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500">Hero MotoCorp Two-Wheeler Insurance</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-4 pl-6">
                  <span className="text-blue-600">Hero MotoCorp Two-Wheeler Insurance </span>  
                </h1>
                <p className="text-lg md:text-base lg:text-lg mt-4 pl-4">
                Hero MotoCorp is one of India’s most trusted two-wheeler brands, known for its reliability, fuel efficiency, and wide service network. Whether you ride a practical Splendor or a sporty Xtreme, keeping your bike protected starts with the right insurance. This guide walks you through what you need to know about insuring a Hero MotoCorp bike, from average premiums and model insights to useful add-ons, renewal tips, and FAQs.
                </p>
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="../assets/heroinsurance11.jpeg"
                alt="Hero MotoCorp Two-Wheeler"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            About Hero MotoCorp in India
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Hero MotoCorp is the world’s largest manufacturer of two-wheelers, by volume. Known for reliable engineering, affordable pricing and strong mileage, Hero bikes and scooters have become a household name across urban and rural India.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            With a wide lineup that spans commuter bikes, stylish scooters and performance-oriented models, Hero appeals to first-time buyers and long-distance riders alike. Top-selling models like the Splendor Plus, HF Deluxe, Passion Pro and Glamour are known for their durability, while scooters like the Maestro Edge and Destini 125 are gaining popularity in cities. Insuring your Hero two-wheeler not only protects against accidents and damage but also ensures you stay legally compliant while enjoying peace of mind on every ride.
          </p>
        </div>
      </div>
       <div className="p-4 sm:p-8 bg-white">
                                                  <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center">
                                                    Choose Your Bike Brand
                                                  </h2>
                                                  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                                                    {heromotocorpInsurance.map((calc, index) => (
                                                      <motion.div
                                                        key={index}
                                                        whileHover={{ scale: 1.04 }}
                                                        initial={{ opacity: 0, y: 20 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ duration: 0.3, delay: index * 0.05 }}
                                                      >
                                                        <Link
                                                          to={calc.path}
                                                          className="flex flex-col items-center justify-center text-center border border-gray-200 rounded-lg p-5 bg-white shadow-sm hover:shadow-md transition-all duration-300 h-full min-h-[160px]"
                                                        >
                                                          <img
                                                            src={calc.image}
                                                            alt={calc.name}
                                                            className="w-16 h-16 object-contain mb-2"
                                                          />
                                                          <span className="text-md font-medium text-gray-800 break-words leading-snug">
                                                            {calc.name}
                                                          </span>
                                                        </Link>
                                                      </motion.div>
                                                    ))}
                                                  </div>
                                                </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
        <div className="w-full max-w-[984px]">
          <AdBanner displayOrder="2" />
        </div>
      </div>
      <section className="relative py-20 px-4 sm:px-8 bg-gradient-to-br from-white to-gray-100 overflow-hidden">
        <div className="absolute inset-0 z-0 pointer-events-none">
          <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-blue-400 opacity-20 blur-3xl rounded-full"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-purple-400 opacity-20 blur-3xl rounded-full"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative z-10 max-w-5xl mx-auto bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl p-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            Why Hero Owners Need Smart Two-Wheeler Insurance
          </h2>
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            Hero bikes and scooters are designed for fuel efficiency and practical utility. But even a low-maintenance vehicle can face unexpected risks like:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2 md:grid-cols-3 text-gray-700 mb-6">
            <li className="flex items-start gap-3">
              <FaCarCrash className="text-xl text-red-500 mt-1" />
              <span>Road accidents and collisions</span>
            </li>
            <li className="flex items-start gap-3">
              <FaUserLock className="text-xl text-yellow-500 mt-1" />
              <span>Theft or vandalism</span>
            </li>
            <li className="flex items-start gap-3">
              <FaCloudSunRain className="text-xl text-blue-500 mt-1" />
              <span>Natural disasters including floods and storms</span>
            </li>
            <li className="flex items-start gap-3">
              <FaShieldAlt className="text-xl text-green-500 mt-1" />
              <span>Fire and explosion</span>
            </li>
            <li className="flex items-start gap-3">
              <FaTools className="text-xl text-indigo-500 mt-1" />
              <span>Third-party liabilities</span>
            </li>
          </ul>
          <div className="bg-indigo-50 border-l-4 border-indigo-400 p-4 rounded-lg text-indigo-700">
            A comprehensive two-wheeler insurance policy helps reduce financial stress during such situations. You also gain access to cashless service centers, fast claims processing and coverage tailored to daily riders.
          </div>
        </motion.div>
      </section>
       <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-10">
            <div className="max-w-xl space-y-6 text-center md:text-left">
              <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
                Calculate Your TwoWheeler Insurance <br />
                in <span className="text-blue-600">Seconds</span>
              </h2>
              <p className="text-gray-700 text-lg">
                Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
              </p>
              <Link
                to="/financial-tools-calculators/bike-insurance-calculator"
                className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
              >
                Start Calculating <ArrowRight className="w-5 h-5" />
              </Link>
            </div>
            <div className="space-y-4 text-left">
              {features.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-xl" role="img" aria-label={item.text}>{item.icon}</span>
                  <span className="text-gray-800 font-medium">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      <div className="container mx-auto p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Popular Hero Models and Insurance Cost Estimates
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Below is a snapshot of popular Hero MotoCorp models in India along with their approximate insured declared value (IDV) and expected insurance premium ranges.
        </p>
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="block md:hidden">
            {[
              { model: "Splendor Plus", category: "Commuter Bike", idv: "60,000 – 75,000", premium: "₹750 – ₹1,000" },
              { model: "HF Deluxe", category: "Budget Bike", idv: "55,000 – 70,000", premium: "₹700 – ₹950" },
              { model: "Passion Pro", category: "Commuter Bike", idv: "65,000 – 85,000", premium: "₹850 – ₹1,200" },
              { model: "Glamour", category: "Premium Commuter", idv: "85,000 – 1,05,000", premium: "₹1,000 – ₹1,300" },
              { model: "Xtreme 160R", category: "Sports Bike", idv: "1.2 – 1.4 Lakh", premium: "₹1,300 – ₹1,800" },
              { model: "Maestro Edge 125", category: "Scooter", idv: "85,000 – 1 Lakh", premium: "₹1,000 – ₹1,400" },
              { model: "Destini 125", category: "Scooter", idv: "80,000 – 95,000", premium: "₹950 – ₹1,300" },
              { model: "Pleasure Plus", category: "Compact Scooter", idv: "70,000 – 85,000", premium: "₹900 – ₹1,200" },
            ].map((item, index) => (
              <div key={index} className="border mb-4 p-4 rounded-lg bg-white shadow-md">
                <h3 className="font-semibold text-gray-800 mb-2">{item.model}</h3>
                <div className="text-gray-600 mb-1"><strong>Category:</strong> {item.category}</div>
                <div className="text-gray-600 mb-1"><strong>Approx. IDV:</strong> {item.idv}</div>
                <div className="text-gray-600"><strong>Starting Premium:</strong> {item.premium}</div>
              </div>
            ))}
          </div>
          <div className="hidden md:block overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
              <thead className="bg-gray-100 text-gray-800">
                <tr>
                  <th className="p-3 border border-gray-300 text-left">Hero Model</th>
                  <th className="p-3 border border-gray-300 text-left">Type</th>
                  <th className="p-3 border border-gray-300 text-left">Approx. IDV (₹)</th>
                  <th className="p-3 border border-gray-300 text-left">Starting Premium (₹)</th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {[
                  ["Splendor Plus", "Commuter Bike", "60,000 – 75,000", "₹750 – ₹1,000"],
                  ["HF Deluxe", "Budget Bike", "55,000 – 70,000", "₹700 – ₹950"],
                  ["Passion Pro", "Commuter Bike", "65,000 – 85,000", "₹850 – ₹1,200"],
                  ["Glamour", "Premium Commuter", "85,000 – 1,05,000", "₹1,000 – ₹1,300"],
                  ["Xtreme 160R", "Sports Bike", "1.2 – 1.4 Lakh", "₹1,300 – ₹1,800"],
                  ["Maestro Edge 125", "Scooter", "85,000 – 1 Lakh", "₹1,000 – ₹1,400"],
                  ["Destini 125", "Scooter", "80,000 – 95,000", "₹950 – ₹1,300"],
                  ["Pleasure Plus", "Compact Scooter", "70,000 – 85,000", "₹900 – ₹1,200"],
                ].map(([model, category, idv, premium], index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="p-3 border border-gray-300">{model}</td>
                    <td className="p-3 border border-gray-300">{category}</td>
                    <td className="p-3 border border-gray-300">{idv}</td>
                    <td className="p-3 border border-gray-300">{premium}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="container mx-auto p-6 mt-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Useful Add-Ons for Hero Two-Wheelers
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Add-ons help enhance your standard policy and offer more robust protection. For Hero vehicles, consider these:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 mt-4">
          {cardsNew.map((card, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center"
            >
              {card.icon}
              <h3 className="text-lg font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
        <div className="w-full max-w-[984px]">
          <AdBanner displayOrder="3" />
        </div>
      </div>
      <div className="mx-auto container p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          Best Insurance Providers for Hero Bikes & Scooters
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          The following insurers offer great coverage options, extensive cashless garage networks and quick settlement for Hero riders:
        </p>
        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">New India Assurance</h3>
            <p className="text-gray-700 text-sm mt-1">Trusted PSU insurer with good rural reach.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🚗</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Digit Insurance</h3>
            <p className="text-gray-700 text-sm mt-1">Digital-first and highly rated for customer service.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏥</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Bajaj Allianz</h3>
            <p className="text-gray-700 text-sm mt-1">Strong garage network and efficient claim process.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">IFFCO Tokio</h3>
            <p className="text-gray-700 text-sm mt-1">Good for first-time two-wheeler buyers.</p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📱</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">Tata AIG</h3>
            <p className="text-gray-700 text-sm mt-1">Known for smart add-on bundling and prompt service.</p>
          </div>
        </div>
      </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-2">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Tips to Lower Your Hero Insurance Premium
              </span>
            </div>
            <h3 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white mb-6">
              Want to reduce your insurance cost without cutting back on coverage? Here’s how:
            </h3>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Use your No Claim Bonus (NCB) to get renewal discounts.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Opt for a higher voluntary deductible if you're a safe rider.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Avoid raising small claims so you can preserve your NCB.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Install anti-theft devices certified by ARAI.</span>
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span>Compare quotes from multiple insurers before renewing.</span>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Needed for Hero Bike Insurance
              </span>
            </div>
            <h3 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white mb-6">
              To buy or renew insurance, keep the following documents ready:
            </h3>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Registration Certificate (RC) of your Hero vehicle</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Previous insurance policy copy (if renewing)</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Valid pollution under control (PUC) certificate</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span>Identity proof (PAN, Aadhaar)</span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span>Passport-sized photograph (if buying offline)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Hero Two-Wheeler Insurance FAQs
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div id={`faq-answer-${index}`} className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <section className="relative py-20 px-4 sm:px-8 bg-gradient-to-br from-white to-gray-100 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none z-0">
          <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-indigo-300 opacity-30 blur-3xl rounded-full"></div>
          <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-purple-300 opacity-30 blur-3xl rounded-full"></div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative z-10 max-w-4xl mx-auto bg-white/90 backdrop-blur-sm border border-gray-200 shadow-xl rounded-2xl p-10"
        >
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="text-indigo-600 text-5xl">
              <FaCarSide />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                Conclusion
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-4">
                Hero MotoCorp is synonymous with affordability, efficiency and wide-spread trust across India. Whether you ride a Splendor, Glamour or Destini 125, the right insurance plan ensures your vehicle is protected at all times.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                At TheFinMaster, we help you compare plans, explore add-ons and make smarter insurance decisions tailored to your Hero vehicle and lifestyle.
              </p>
            </div>
          </div>
        </motion.div>
      </section>
    </>
  );
};

export default HeroMotoCorpTwoWheelerInsurance;